import React, { useState } from 'react';

import Menu from '../../../components/globalComponents/headerMenu/menu';
import ContactUs from '../../../components/companyInfoComponents/contactUs/contactUs';
import SocialIcons from '../../../components/globalComponents/socialIcons/socialIcons';
import GradientLine from '../../../components/globalComponents/gradientLine/gradientLine';
import Footer from '../../../components/globalComponents/footer/footer';
import ProductoInfoHeader from '../../../components/productsInfoComponents/productoInfoHeader/productoInfoHeader';
import ProductoInfoCompany from '../../../components/productsInfoComponents/productsInfoCompany/productsInfoCompany';
import ProductsWonderaly from '../../../components/productsInfoComponents/productsWonderaly/productsWonderaly';

import './productsinfoPage.scss';

const ProductsInfoPage = () => {
  const [isOffcanvasOpen, setIsOffcanvasOpen] = useState(false);
  return (
    <>
      <Menu
        isOffcanvasOpen={isOffcanvasOpen}
        setIsOffcanvasOpen={setIsOffcanvasOpen}
      />
      <div className="">
        <ProductoInfoHeader />
        <ProductoInfoCompany />
        <ProductsWonderaly />
      </div>
      <ContactUs />
      <SocialIcons />
      <GradientLine />
      <Footer />
    </>
  );
};

export default ProductsInfoPage;
